import { render, staticRenderFns } from "./class-level-card.vue?vue&type=template&id=4540b396&scoped=true"
import script from "./class-level-card.ts?vue&type=script&lang=ts&external"
export * from "./class-level-card.ts?vue&type=script&lang=ts&external"
import style0 from "./class-level-card.scss?vue&type=style&index=0&id=4540b396&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540b396",
  null
  
)

export default component.exports